import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=6a45b698&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"
import style0 from "./popup.vue?vue&type=style&index=0&id=6a45b698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45b698",
  null
  
)

export default component.exports